import * as types from "@/store/mutation-types";
import uuidv1 from "uuid/v1";

const initial = {
  id: -1,
  open: false,
  text: "",
  timeout: 0
};

const state = {
  queue: [],
  message: {
    ...initial
  }
};

export const getters = {
  id: state => state.message.id,
  open: state => state.message.open,
  text: state => state.message.text
};

export const actions = {
  add({ commit, dispatch }, message) {
    message.id = uuidv1();
    if (message.open === undefined) {
      message.open = true;
    }
    if (message.timeout === undefined) {
      message.timeout = 5000;
    }
    commit(types.ENQUEUE_MESSAGE, message);
    dispatch("update");
  },
  dismiss({ commit, dispatch }, id) {
    commit(types.DEQUEUE_MESSAGE, id);
    commit(types.UPDATE_MESSAGE, initial);
    setTimeout(function() {
      dispatch("update");
    }, 100);
  },
  reset({ commit }) {
    commit(types.RESET_SNACKBAR);
  },
  update({ commit, dispatch, state }) {
    if (state.message.id === -1) {
      if (state.queue.length) {
        const next = state.queue[0];
        if (next.timeout !== 0 && next.timeout !== null) {
          setTimeout(function() {
            dispatch("dismiss", next.id);
          }, next.timeout);
        }
        commit(types.UPDATE_MESSAGE, initial);
        commit(types.UPDATE_MESSAGE, next);
      }
    }
  }
};

export const mutations = {
  [types.UPDATE_MESSAGE](state, message) {
    state.message = message;
  },
  [types.ENQUEUE_MESSAGE](state, message) {
    state.queue.push(message);
  },
  [types.DEQUEUE_MESSAGE](state, id) {
    const index = state.queue.findIndex(message => message.id === id);
    if (index !== -1) {
      state.queue = state.queue.slice(1);
    }
  },
  [types.RESET_SNACKBAR](state) {
    state.queue = [];
    state.message = { ...initial };
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
